import { Outlet, Navigate } from 'react-router-dom';

function GuardedRoute({ isAuth = false, location = null }) {
  if (isAuth) {
    return <Outlet />;
  }else{
    return <Navigate to="/login" />;
  }
}

export default GuardedRoute;
